module.exports = __webpack_public_path__ + "Roboto-Thin-webfont.dea9a5a98e3a91326f65.svg";


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/src/assets/fonts/roboto/roboto_thin_macroman/Roboto-Thin-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto/roboto_thin_macroman/Roboto-Thin-webfont.svg
// module chunks = 1